

















































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils";
const addNewQuestion = () => import("./component/addNewQuestion.vue");

@Component({
  name: "QuestionConfiguration",
  components: {
    addNewQuestion,
  },
})
export default class QuestionConfiguration extends Vue {
  @Provide() private activeName: string = "second";
  @Provide() private resultData: any = []; //列表
  @Provide() private result: any = {
    id: "",
    qptype: "",
    value: "",
    options: "",
    optionsdisplay: "",
    questionkey: "",
  };
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private isShow: boolean = false;
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private QpType: any = "";
  @Provide() private name: any = "";
  @Provide() private title: any = "添加";

  @Provide() private questionOptions: any = [
    { id: 1, name: "0类问题" },
    { id: 2, name: "1类问题" },
    { id: 3, name: "2类问题" },
  ];
  @Provide() private isAddQuestion: boolean = false; // lee 是否展示添加弹窗

  private created() {
    this.token = localStorage.getItem("token");
    this.searchFormAction();
  }
  private selectList() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.searchFormAction();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.searchFormAction();
  }

  private updateList() {
    this.pageIndex = 1;
    this.QpType = "";
    this.name = "";
    this.searchFormAction();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.searchFormAction();
    }
  }
  // 隐藏添加弹窗
  private returnRiskReport() {
    this.isAddQuestion = false;
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.searchFormAction();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.searchFormAction();
  }

  private hideDialog(): void {
    this.isAddQuestion = false;
  }
  // lee 关闭所有弹窗
  private hideAllDialog() {
    this.isAddQuestion = false;
    this.searchFormAction();
  }
  // 列表
  private async searchFormAction() {
    this.isSearchFormActionDone = true;
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      QpType: this.QpType,
      Value: this.name,
    };
    const { getListQuestionReq, getListQuestionRequest }: any = await import(
      "@/request/questionConfiguration"
    );
    let res = await getListQuestionRequest.handleHttp(getListQuestionReq(_arg), this);
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res && res.right) {
      this.pagerCount = res.pageout.total;
      this.resultData = res.listList && res.listList.length > 0 ? res.listList : [];
      this.resultData.forEach((item: any) => {
        let qptypemes = "";
        switch (item.qptype) {
          case 1:
            qptypemes = "0类问题";
            break;
          case 2:
            qptypemes = "1类问题";
            break;
          case 3:
            qptypemes = "2类问题";
            break;
        }
        let associateditemsListName: any = [];
        let associateditemsListNames: any = [];
        let associateditemsLisIds: any = [];
        item.associateditemsList.forEach((data: any) => {
          associateditemsListName.push(data.name);
          associateditemsListNames.push(data.name);
          associateditemsLisIds.push(data.verifyinfoid);
        });
        let optionsdisplayList: any = [];
        let optionsdisplayLists: any = [];
        optionsdisplayList = item.optionsdisplay.split(";");
        optionsdisplayLists = item.optionsdisplay.split(";");
        this.$set(item, "qptypemes", qptypemes);
        // 信息关联associateditemsListName和associateditemsListNames，为了tooltip
        this.$set(
          item,
          "associateditemsListName",
          associateditemsListName.join("<br/><br/>")
        );
        this.$set(item, "associateditemsListNames", associateditemsListNames.join(" "));
        this.$set(item, "associateditemsLisIds", associateditemsLisIds);
        this.$set(item, "optionsdisplayList", optionsdisplayList.join("<br/><br/>"));
        this.$set(item, "optionsdisplayLists", optionsdisplayLists.join(" "));
        this.$set(item, "utimes", timeFormat(Number(item.utime)));
      });
    } else {
      this.isSearchFormActionDone = false;
    }
  }
  private editLoadAttr(row: any) {
    this.result = {
      id: row.id,
      defaultnormal:row.defaultnormal,
      qptype: row.qptype,
      value: row.value,
      options: row.options,
      questionkey: row.questionkey,
      associateditemsList: row.associateditemsList ? row.associateditemsList : [],
      associateditemsLisIds: row.associateditemsLisIds ? row.associateditemsLisIds : [],
    };
    this.isAddQuestion = true;
    if (row.id) {
      this.title = "编辑";
    } else {
      this.title = "添加";
    }
  }
  // 点击删除
  private deleteAction(row: any) {
    this.$confirm(
      row.status == "3"
        ? "这条问题已经在审核页面中展示，确认要删除吗?"
        : "确认要删除这条问题吗？",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(() => {
        this.toDelete(row);
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
  }
  private async toDelete(row: any) {
    let _arg: any = {
      id: row.id,
      qptype: row.qptype,
      value: row.value,
      options: row.options,
      associatedItemsList: row.associateditemsList,
      optionsdisplay: row.optionsdisplay,
      status: row.status,
      opuid: row.opuid,
      utime: row.utime,
      opname: row.opname,
    };
    const { getDelQuestionReq, getDelQuestionRequest }: any = await import(
      "@/request/questionConfiguration"
    );
    let res = await getDelQuestionRequest.handleHttp(getDelQuestionReq(_arg), this);
    if (res.code === 0) {
      this.$message({
        type: "success",
        message: "删除成功",
      });
      this.updateList();
    }
  }
}
